<template lang='pug'>
  form.forms.referral.component.container( @submit.prevent='refer' )
    close-button( @click.native='$emit("close")' )

    section.heading
      h3 {{ $t('Invite a Merchant') }}

    fieldset
      label {{ $t("Merchant's Name") }}
      bf-input.basic
        input( type='text' v-model='referral.name' required )

    fieldset
      label {{ $t("Merchant's Email") }}
      bf-input.basic
        input( type='email' v-model='referral.email' required )

    fieldset
      label {{ $t('Message') }}
      bf-input.basic
        textarea( v-model='referral.message' )

    fieldset.centered-text
      bf-button.wide( type='submit' )
        template( v-slot:text ) {{ text }}
</template>

<script>
  import { db } from '@/main'
  import CloseButton from '@/components/buttons/close'

  export default {
    name: 'forms.referral',

    components: {
      CloseButton
    },

    props: {
      account: { type: Object, required: true },
      referrals: { type: Array, required: true},
      biz: { type: Object, default: null },
      type: { type: String, default: 'direct' }
    },

    data() {
      return {
        referral: {},
        text: this.$t('Send Invitation')
      }
    },

    methods: {
      refer() {
        this.text = 'Submitting...'
        let existing = this.referrals.find( r => r.to.email == this.referral.email )
        
        if ( existing ) {
          this.text = `Referral with Email ${ this.referral.email } Already Exists! Resetting in 5 secs`
          setTimeout( () => {
            this.referral = {}
            this.text='Send Invitation'
          }, 5000 )
          return
        }
        
        db.collection( 'accounts' ).where( 'email', '==', this.referral.email ).get().then( referrals => {
          if ( referrals.docs.length ) {
            this.text = this.$t( 'User Already Exists! Resetting in 5 secs' )
            if ( this.account.merchant ) db.collection( 'advertisements' ).add({
              by: this.account,
              for: this.biz,
              to: referrals.docs[0].data(),
              on: new Date()
            })
            setTimeout( () => {
              this.referral = {}
              this.text= this.$t( 'Send Invitation' )
            }, 5000 )
          }
          else {
            let doc = {
              status: 'invited',
              type: this.type,
              by: this.account,
              to: this.referral,
              on: new Date()
            }
            db.collection( 'referrals' ).add( doc ).then( doc => {
              this.text = 'Complete. Resetting in 5 secs'
              setTimeout( () => {
                this.referral = {}
                this.text='Send Invitation'
              }, 5000 )
            })
          }
        })
      }
    }
  }
</script>

<style scoped lang="stylus">
  .referral
    background white
    border-radius 9px
    width 320px

    section
      padding 16px 32px
      background rgba( 0 0 0 .1 )

    fieldset
      padding 16px 32px

    label
      display block
      font-weight bold
      margin 4px
      margin-top 32px
      &:first-child 
        margin-top 0
    
    .close
      position absolute
      right -6px
      top -6px
      background white
</style>